module.exports = __webpack_public_path__ + "static/009-slideshow-5c973fee5ea437023cde5dd8063ea17d.jpg";